import { gql } from '@apollo/client/core';

const WarRoomOnboardingDataQuery = gql`
  query OnboardingData {
    onboardingData {
      departments {
        id
        name
        emoji
      }
      companyStages {
        id
        name
      }
      customerSegments {
        id
        name
        emoji
      }
      industries {
        id
        name
        emoji
      }
      expectations {
        id
        name
      }
      jobSearchStatuses
    }
  }
`;

export default WarRoomOnboardingDataQuery;
